import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { IContactInformation } from "@/shop/types/contacts";

import * as ContactActions from "./actions";

export type ContactAction = ActionType<typeof ContactActions>;

export interface IContactsReducerState {
  contacts: IContactInformation;
  hasError: boolean;
  isFetching: boolean;
}

const initialState: IContactsReducerState = {
  contacts: null!,
  hasError: false,
  isFetching: false
};

interface IContactsUpdate {
  contacts: IContactInformation;
  hasError: boolean;
  isFetching: boolean;
}

function updateContactsState(state: IContactsReducerState, { contacts, hasError, isFetching }: IContactsUpdate): IContactsReducerState {
  return {
    ...state,
    contacts: { ...state.contacts, ...contacts },
    isFetching,
    hasError
  };
}

export default function contactsReducer(state = initialState, action: ContactAction): IContactsReducerState {
  switch (action.type) {
    case getType(ContactActions.fetchContactsStart): {
      return updateContactsState(state, { isFetching: true, hasError: false, contacts: null! });
    }

    case getType(ContactActions.fetchContactsFail): {
      return updateContactsState(state, { isFetching: false, hasError: true, contacts: null! });
    }

    case getType(ContactActions.fetchContactsSuccess): {
      const { contacts } = action.payload;
      return updateContactsState(state, { isFetching: false, hasError: false, contacts });
    }

    default:
      return state;
  }
}
